exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n#hot-news img{\n  width: auto!important;\n}\n#hot-news tr{\n  line-height: 2;\n}\n.mce-container.mce-panel.mce-floatpanel.mce-popover.mce-bottom{\n  top: calc(100vh - 20vh - 250px)!important;\n}\n@media screen and (max-width: 767px) {\n  #hot-news img{\n    width: 100%!important;\n  }\n  #hot-news tr{\n    font-size: 12px;\n  }\n  #hot-news iframe{\n    width: 100%;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 389
// module chunks = 9